export default __webpack_public_path__ + "static/media/breadcrumb_bottom.dd6d4ab7.svg";